import React from 'react';

const painPoints = [
  "Tu dors avec ton téléphone.",
  "Tu as pris 8 kilos depuis que tu as lancé ta boîte.",
  "Tu gagnes plus qu'avant, mais tu ris moins.",
  "Tu es entouré toute la journée, et pourtant personne ne comprend ce que tu portes.",
  "Ta dernière vraie décision stratégique date de quand ?",
];

const TargetSection = ({ onJoinExperience }) => {
  return (
    <div className="bg-black py-20 md:py-28 px-6 border-t border-white/5" data-testid="target-section">
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-[#D4A574] text-[10px] tracking-[0.4em] mb-6">C'EST POUR TOI SI...</p>
        <h2 className="font-italiana text-3xl md:text-4xl lg:text-5xl text-white tracking-[0.08em] uppercase mb-12">
          Tu te <span className="text-[#D4A574]">reconnais</span> ?
        </h2>
        
        {/* Brutal pain points */}
        <div className="space-y-6 mb-12">
          {painPoints.map((point, i) => (
            <p 
              key={i} 
              className="text-white/80 text-lg md:text-xl leading-relaxed"
            >
              {point}
            </p>
          ))}
        </div>

        <div className="border-t border-white/10 pt-10 mt-10">
          <p className="text-white/50 text-sm mb-8 max-w-xl mx-auto">
            Si tu as hoché la tête au moins une fois, ce camp est fait pour toi.
          </p>
          
          <button
            onClick={onJoinExperience}
            data-testid="target-join-btn"
            className="bg-[#D4A574] hover:bg-[#C39563] text-white px-10 py-4 rounded-full text-sm tracking-[0.2em] font-medium transition-all hover:scale-105 uppercase"
          >
            Je veux ma place
          </button>
        </div>
      </div>
    </div>
  );
};

export default TargetSection;
